#import "../NoteFields.graphql"

query GetHifoCascade($id: ID!) {
  hifoCascade(id: $id) {
    id
    status
    deadline
    currentTrancheNumber
    notes
    statusChangeNotes
    roomForFunding {
      currency
      minorUnit
    }
    minimumGrantAmount {
      currency
      minorUnit
    }
    hifo {
      id
      name
      expiryDate
      roomForFunding {
        currency
        minorUnit
      }
      minDonationAmount {
        currency
        minorUnit
      }
    }
    owner {
      id
      name
    }
    pitches {
      id
      hifoCascadeId
      trancheNumber
      position
      status
      deadline
      notes
      reasonForRejection
      pitchedAmount {
        currency
        minorUnit
      }
      committedAmount {
        currency
        minorUnit
      }
      grantedAmount {
        currency
        minorUnit
      }
      contact {
        id
        firstName
        lastName
      }
      owner {
        id
        name
        user {
          avatarUrl
        }
      }
      pitchMaterials {
        id
        name
        url
        createdAt
      }
      pitchNotes {
        ...NoteFields
      }
      createdBy {
        id
        email
      }
      updatedBy {
        id
        email
      }
      createdAt
      updatedAt
    }
    createdBy {
      id
      email
    }
    updatedBy {
      id
      email
    }
    createdAt
    updatedAt
  }
}
